import * as React from 'react';
export default function useCacheDisplayValue(values) {
    const prevValuesRef = React.useRef(values);
    const mergedValues = React.useMemo(() => {
        const valueLabels = new Map();
        prevValuesRef.current.forEach(({ value, label }) => {
            if (value !== label) {
                valueLabels.set(value, label);
            }
        });
        const resultValues = values.map(item => {
            const cacheLabel = valueLabels.get(item.value);
            if (item.isCacheable && cacheLabel) {
                return Object.assign(Object.assign({}, item), { label: cacheLabel });
            }
            return item;
        });
        prevValuesRef.current = resultValues;
        return resultValues;
    }, [values]);
    return mergedValues;
}
